export const ModalSizeStyle = {
  small: 'width-sm',
  medium: 'width-md',
  large: 'width-lg',
  xLarge: 'width-xl'
};

export const ModalType = {
  primary: 'primary',
  secondary: 'secondary',
  simple: 'simple',
  fullWindow: 'fullWindow'
};
